// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-history {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.session-history h3 {
  margin-top: 0;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.empty-sessions {
  color: #7f8c8d;
  text-align: center;
  padding: 2rem 0;
}

.sessions-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.session-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.session-card:hover {
  background-color: #e9ecef;
  transform: translateX(4px);
}

.session-date {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.date-day {
  font-weight: 500;
  color: #2c3e50;
}

.date-time {
  font-size: 0.875rem;
  color: #7f8c8d;
}

.session-status {
  flex: 1 1;
  text-align: center;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.completed {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.active {
  background-color: #fff3cd;
  color: #856404;
}

.session-arrow {
  font-size: 1.25rem;
  color: #3498db;
  transition: transform 0.2s;
}

.session-card:hover .session-arrow {
  transform: translateX(4px);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .session-history {
    padding: 1rem;
  }

  .session-history h3 {
    font-size: 1.1rem;
  }

  .session-card {
    padding: 0.85rem;
  }

  .date-day {
    font-size: 0.95rem;
  }

  .date-time {
    font-size: 0.8rem;
  }

  .status-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.6rem;
  }

  .session-arrow {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .session-history {
    padding: 0.75rem;
  }

  .session-history h3 {
    font-size: 1rem;
  }

  .session-card {
    padding: 0.75rem;
  }

  .date-day {
    font-size: 0.9rem;
  }

  .date-time {
    font-size: 0.75rem;
  }

  .status-badge {
    font-size: 0.65rem;
    padding: 0.15rem 0.5rem;
  }

  .session-status {
    flex: 0 1;
    margin: 0 0.5rem;
  }

  .session-arrow {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SessionHistory.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".session-history {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.session-history h3 {\n  margin-top: 0;\n  color: #2c3e50;\n  margin-bottom: 1rem;\n}\n\n.empty-sessions {\n  color: #7f8c8d;\n  text-align: center;\n  padding: 2rem 0;\n}\n\n.sessions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.session-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.session-card:hover {\n  background-color: #e9ecef;\n  transform: translateX(4px);\n}\n\n.session-date {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.date-day {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.date-time {\n  font-size: 0.875rem;\n  color: #7f8c8d;\n}\n\n.session-status {\n  flex: 1;\n  text-align: center;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.completed {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-badge.active {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.session-arrow {\n  font-size: 1.25rem;\n  color: #3498db;\n  transition: transform 0.2s;\n}\n\n.session-card:hover .session-arrow {\n  transform: translateX(4px);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .session-history {\n    padding: 1rem;\n  }\n\n  .session-history h3 {\n    font-size: 1.1rem;\n  }\n\n  .session-card {\n    padding: 0.85rem;\n  }\n\n  .date-day {\n    font-size: 0.95rem;\n  }\n\n  .date-time {\n    font-size: 0.8rem;\n  }\n\n  .status-badge {\n    font-size: 0.7rem;\n    padding: 0.2rem 0.6rem;\n  }\n\n  .session-arrow {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .session-history {\n    padding: 0.75rem;\n  }\n\n  .session-history h3 {\n    font-size: 1rem;\n  }\n\n  .session-card {\n    padding: 0.75rem;\n  }\n\n  .date-day {\n    font-size: 0.9rem;\n  }\n\n  .date-time {\n    font-size: 0.75rem;\n  }\n\n  .status-badge {\n    font-size: 0.65rem;\n    padding: 0.15rem 0.5rem;\n  }\n\n  .session-status {\n    flex: 0;\n    margin: 0 0.5rem;\n  }\n\n  .session-arrow {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
